export const NotFoundPage = () => (
  // eslint-disable-next-line react/forbid-elements
  <section>
    <h1 className="text-center text-[10rem] font-bold">404</h1>

    {/* eslint-disable-next-line react/forbid-elements */}
    <p className="text-center text-[3rem]">Nothing here 🌵</p>
  </section>
)
